import { APP_WILL_MOUNT } from '../base/app/actionTypes';
import MiddlewareRegistry from '../base/redux/MiddlewareRegistry';
import { getJitsiMeetGlobalNS } from '../base/util/helpers';
import { setCustomPanelEnabled } from './actions.web';
/**
 * Middleware that exposes a function to enable/disable the custom panel.
 * This allows toggling the feature dynamically from the browser console.
 */
MiddlewareRegistry.register((store) => (next) => (action) => {
    const result = next(action);
    if (action.type === APP_WILL_MOUNT) {
        const globalNS = getJitsiMeetGlobalNS();
        // Expose enable/disable function on global namespace for console access.
        globalNS.enableCustomPanel = (enabled = true) => {
            store.dispatch(setCustomPanelEnabled(enabled));
        };
    }
    return result;
});
